exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n#logo { margin-right: 5px }\n\n#brand { color: #fff }\n\nmat-sidenav-container {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n\nmat-sidenav {\n  width: 280px;\n}\n\n.scrollable {\n  overflow: auto;\n}\n\n@media print {\n  .no-print { display: none }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main